var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutlooks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.91663 10.4998C2.91663 6.58782 6.08794 3.4165 9.99996 3.4165C13.912 3.4165 17.0833 6.58782 17.0833 10.4998C17.0833 14.4118 13.912 17.5832 9.99996 17.5832C6.08794 17.5832 2.91663 14.4118 2.91663 10.4998ZM9.99996 2.1665C5.39758 2.1665 1.66663 5.89746 1.66663 10.4998C1.66663 15.1022 5.39758 18.8332 9.99996 18.8332C14.6023 18.8332 18.3333 15.1022 18.3333 10.4998C18.3333 5.89746 14.6023 2.1665 9.99996 2.1665ZM5.90287 7.75623C5.56431 6.90667 6.40655 6.0644 7.25613 6.40294L10.613 7.74057C11.5898 8.12985 12.3717 8.89184 12.7859 9.85842L14.3307 13.4629C14.7011 14.3273 13.8272 15.2011 12.9629 14.8307L9.35838 13.2859C8.39188 12.8717 7.62985 12.0898 7.24056 11.113L5.90287 7.75623ZM7.24337 7.74345L8.40179 10.6503C8.66813 11.3186 9.18946 11.8536 9.85079 12.137L12.9766 13.4766L11.637 10.3508C11.3535 9.6895 10.8186 9.16809 10.1502 8.90175L7.24337 7.74345Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlooks);
export default __webpack_public_path__ + "static/media/outlooks.a7c0391fa3a48ac620b718c77ad70604.svg";
export { ForwardRef as ReactComponent };